import { createSlice } from "@reduxjs/toolkit";
import { getMyHelpRequests } from "./Thunk";

export const helpDesk = createSlice({
  name: "helpDesk",
  initialState: {
    myHelpRequests: [],
    isLoading: false,
  },
  reducers: {
    UpdateCompanyId(state, action) {
      state.companyId = action.payload.companyId;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getMyHelpRequests.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getMyHelpRequests.fulfilled, (state, action) => {
      state.myHelpRequests = action.payload;
      state.isLoading = false;
    });
  },
});

export const {} = helpDesk.actions;

export default helpDesk.reducer;
